import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getSession } from '../lib/session.ts';

const SuccessPage = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const session = getSession();

  useEffect(() => {
    if (!session || !session.otp) {
      navigate('/identification');
    }
  }, [navigate, session]);

  if (!session) return null;

  return (
    <main className="space-y-8">
      <section className="rounded-3xl bg-white p-8 shadow-md shadow-slate-200">
        <p className="text-sm uppercase tracking-[0.3em] text-red-600">Sucesso</p>
        <h1 className="mt-4 text-3xl font-semibold text-red-600">Acordo finalizado com sucesso</h1>
        <p className="mt-3 text-slate-600">Parabéns! Seu acordo {code} foi concluído e você está no caminho para ficar em dia.</p>
      </section>

      <section className="rounded-3xl bg-red-50 p-8 shadow-sm">
        <div className="space-y-4 text-slate-700">
          <p className="text-base font-semibold text-slate-600">Próximos passos</p>
          <ul className="list-inside list-disc space-y-2 text-sm leading-7">
            <li>Um dos nossos colaboradores irá entrar em contato em breve, assim que revisar o termo e o pagamento.</li>
            <li>Caso tenha registros no orgãos de proteção ao crédito ou restrições judiciais, elas serão removidas após a verificação de um dos nosso colaboradores.</li>
            <li>Se precisar, já pode estar nos chamando agora, responderemos assim que possivel.</li>
          </ul>
        </div>
      </section>

      <button
        onClick={() => navigate('/companies')}
        className="w-full rounded-2xl bg-red-600 text-white px-5 py-4 text-sm font-semibold shadow-lg transition hover:bg-red-700"
      >
        Voltar para inicio e verificar se tenho alguma pendencia outra unidade
      </button>
    </main>
  );
};

export default SuccessPage;
